import { makeStyles } from "tss-react/mui"
import { Grid, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTabletScreen, faTv, faPrint, faCreditCard, faCheck, faQuestion } from "@fortawesome/pro-light-svg-icons"
import { LocalizedEnum } from "../../../localization/components/AppLocalized"
import { DeviceType } from "../deviceTypes"

const useStyles = makeStyles()((theme) => ({
    title: {
        fontWeight: "600",
        color: theme.palette.tailwind.sky[700],
    },
    iconWrap: {
        position: "relative",
    },
    icon: {
        color: theme.palette.tailwind.sky[700],
        fontSize: "3rem",
    },
    iconPosition: {
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        top: "0.25rem",
    },
    iconCheck: {
        color: theme.palette.tailwind.green[500],
        fontSize: "1.5rem",
    },
    iconQuestion: {
        color: theme.palette.tailwind.sky[700],
        fontSize: "1.5rem",
    },
}))

type DeviceDetailsDialogDeviceTypeSectionProps = Readonly<{
    type: DeviceType | string
}>

export function DeviceDetailsDialogDeviceTypeSection({ type }: DeviceDetailsDialogDeviceTypeSectionProps) {
    const { classes, cx } = useStyles()

    const IconType = (() => {
        switch (type) {
            case DeviceType.CLOUD_POS:
                return <FontAwesomeIcon icon={faTabletScreen} className={classes.icon} />
            case DeviceType.SOFT_POS:
                return <FontAwesomeIcon icon={faTabletScreen} className={classes.icon} />
            case DeviceType.DISPLAY:
                return <FontAwesomeIcon icon={faTv} className={classes.icon} />
            case DeviceType.CLOUD_CREDIT_CARD_READER:
                return <FontAwesomeIcon icon={faCreditCard} className={classes.icon} />
            case DeviceType.STAR_CLOUD_PRINTER:
                return <FontAwesomeIcon icon={faPrint} className={classes.icon} />
            case DeviceType.RECEIPT_CONTROL:
                return (
                    <Grid position="relative">
                        <FontAwesomeIcon icon={faTabletScreen} className={classes.icon} />
                        <FontAwesomeIcon icon={faCheck} className={cx(classes.iconCheck, classes.iconPosition)} />
                    </Grid>
                )
            default:
                return (
                    <Grid position="relative">
                        <FontAwesomeIcon icon={faTabletScreen} className={classes.icon} />
                        <FontAwesomeIcon icon={faQuestion} className={cx(classes.iconQuestion, classes.iconPosition)} />
                    </Grid>
                )
        }
    })()

    return (
        <Grid container flexDirection="column" alignItems="center" gap={1}>
            {IconType}
            <LocalizedEnum base="device-details-type-mode" enumValue={type}>
                <Typography variant="h6" className={classes.title}>
                    {type}
                </Typography>
            </LocalizedEnum>
        </Grid>
    )
}
